import { BiHome } from "react-icons/bi";
import { useNavigate } from "react-router";

import { Stack, Text, Button } from "@chakra-ui/react";

import { CenteredLayout } from "@/components/2/CenteredLayout";
import { OuterShell } from "@/components/2/Shell";

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <OuterShell>
      <CenteredLayout maxW="lg">
        <Stack gap="6">
          <Stack gap={{ base: "2", md: "3" }} textAlign="center">
            <Text color="fg.muted" fontWeight="semibold" fontSize="lg">
              Page non trouvée
            </Text>
            <Text color="fg.muted">
              Cette page n'existe pas ou tu n'as peut-être pas les permissions nécessaires pour y
              accéder.
            </Text>
          </Stack>
        </Stack>

        <Button
          variant="outline"
          onClick={() => navigate("/")}
          display="flex"
          alignItems="center"
          gap={2}
        >
          <BiHome />
          <Text>Retour à l'accueil</Text>
        </Button>

        <Stack gap="3" justify="center">
          <Text textStyle="sm" color="fg.muted" textAlign="center">
            Si tu penses que tu devrais avoir accès à cette page, rapproche-toi de ton manager.
          </Text>
        </Stack>
      </CenteredLayout>
    </OuterShell>
  );
};
